import React from "react";
import Icon from "../icon/icon";
import { ITEMS_PER_PAGE_OPTIONS } from "../../constants/pagination";
import "./pagination-controls.css";

// Pagination controls props interface
export interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (itemsPerPage: number) => void;
  totalItems: number;
}

/**
 * Reusable pagination controls component
 */
export const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalPages,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  totalItems,
}) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const handlePrevious = (): void => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = (): void => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleItemsPerPageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    onItemsPerPageChange(parseInt(event.target.value));
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="pagination-controls">
      <div className="pagination-info">
        <span>
          Показано {startItem}-{endItem} из {totalItems} записей
        </span>
        <div className="items-per-page">
          <label htmlFor="items-per-page">Записей на странице:</label>
          <select
            id="items-per-page"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
          >
            {ITEMS_PER_PAGE_OPTIONS.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="pagination-buttons">
        <button
          type="button"
          className="pagination-button"
          onClick={handlePrevious}
          disabled={currentPage === 1}
          aria-label="Предыдущая страница"
        >
          <Icon name="ic-left" />
        </button>

        <div className="page-numbers">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              type="button"
              className={`page-number ${currentPage === page ? "active" : ""}`}
              onClick={() => onPageChange(page)}
              aria-label={`Страница ${page}`}
            >
              {page}
            </button>
          ))}
        </div>

        <button
          type="button"
          className="pagination-button"
          onClick={handleNext}
          disabled={currentPage === totalPages}
          aria-label="Следующая страница"
        >
          <Icon name="ic-right" />
        </button>
      </div>
    </div>
  );
};
